import { render, staticRenderFns } from "./LoversSpot.vue?vue&type=template&id=708c35fe&scoped=true"
import script from "./LoversSpot.vue?vue&type=script&lang=js"
export * from "./LoversSpot.vue?vue&type=script&lang=js"
import style0 from "./LoversSpot.vue?vue&type=style&index=0&id=708c35fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c35fe",
  null
  
)

export default component.exports